import { Plugin } from '@ckeditor/ckeditor5-core';
import InsertResourcesCommand from './resources-command';
export default class ResourcesEditing extends Plugin {
    init() {
        this.editor.commands.add('insertResources', new InsertResourcesCommand(this.editor));
        this._defineSchema();
        this._defineConverters();
        this._definePostFixer();
    }
    _defineSchema() {
        const schema = this.editor.model.schema;
        schema.register('resources', {
            allowWhere: '$block',
            allowContentOf: '$root',
        });
    }
    _defineConverters() {
        const conversion = this.editor.conversion;
        conversion.for('upcast').elementToElement({
            model: 'resources',
            view: 'x-resources',
        });
        conversion.for('dataDowncast').elementToElement({
            model: 'resources',
            view: 'x-resources',
        });
        conversion.for('editingDowncast').elementToElement({
            model: 'resources',
            view: {
                name: 'div',
                classes: 'resources',
            },
        });
    }
    _definePostFixer() {
        const editor = this.editor;
        const schema = editor.model.schema;
        // Postfixer which cleans incorrect model states connected with resources.
        editor.model.document.registerPostFixer((writer) => {
            const changes = editor.model.document.differ.getChanges();
            for (const entry of changes) {
                if (entry.type == 'insert') {
                    const element = entry.position.nodeAfter;
                    if (!element) {
                        // We are inside a text node.
                        continue;
                    }
                    if (element.is('element', 'resources') && element.isEmpty) {
                        // Added an empty resources - remove it.
                        writer.remove(element);
                        return true;
                    }
                    else if (element.is('element', 'resources') &&
                        !schema.checkChild(entry.position, element)) {
                        // Added a resources in incorrect place - most likely inside another resources. Unwrap it
                        // so the content inside is not lost.
                        writer.unwrap(element);
                        return true;
                    }
                    else if (element.is('element')) {
                        // Just added an element. Check its children to see if there are no nested resources somewhere inside.
                        const range = writer.createRangeIn(element);
                        for (const child of range.getItems()) {
                            if (child.is('element', 'resources') &&
                                !schema.checkChild(writer.createPositionBefore(child), child)) {
                                writer.unwrap(child);
                                return true;
                            }
                        }
                    }
                }
                else if (entry.type == 'remove') {
                    const parent = entry.position.parent;
                    if (parent.is('element', 'resources') && parent.isEmpty) {
                        // Something got removed and now resources is empty. Remove the resources as well.
                        writer.remove(parent);
                        return true;
                    }
                }
            }
            return false;
        });
    }
}
